import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome to curbside!");
      nav("/browse", { replace: true });
    } else { setError(res.error); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-5 py-12">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[#E8E5F0] p-8 sm:p-10 fade-in-up">
        <h1 className="font-display text-3xl tracking-tight font-medium">Join the block</h1>
        <p className="text-[#6B7280] mt-2">Create an account to post things and help reduce waste.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="name">Name</Label>
            <Input id="name" type="text" value={name} onChange={(e) => setName(e.target.value)}
              required className="mt-1.5 h-11 rounded-xl" data-testid="register-name" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              required className="mt-1.5 h-11 rounded-xl" data-testid="register-email" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              required minLength={6} className="mt-1.5 h-11 rounded-xl" data-testid="register-password" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="register-error">{error}</p>}
          <Button type="submit" disabled={loading}
            className="w-full h-11 rounded-full bg-[#7C3AED] hover:bg-[#5B21B6] text-white"
            data-testid="register-submit">
            {loading ? "Creating account…" : "Create account"}
          </Button>
        </form>
        <p className="text-sm text-[#6B7280] mt-6 text-center">
          Already a member? <Link to="/login" className="text-[#7C3AED] hover:underline" data-testid="register-login-link">Log in</Link>
        </p>
      </div>
    </div>
  );
}
